'use strict';

export const routerDecorator = [
  '$rootScope',
  '$state',
  'AuthSvc',
  function($rootScope, $state, AuthSvc) {
  // Redirect to login if route requires auth and the user is not logged in,
  // or doesn't have required role

    $rootScope.$on('$stateChangeStart', function(event, next) {
      if(!next.authenticate) {
        return;
      }

      if(typeof next.authenticate === 'string') {
        AuthSvc.hasRole(next.authenticate)
          .then(has => {
            if(has) {
              return;
            }

            event.preventDefault();
            return AuthSvc.isLoggedIn()
              .then(is => {
                $state.go(is ? 'main' : 'login');
              });
          });
      } else {
        AuthSvc.isLoggedIn()
          .then(is => {
            if(is) {
              return;
            }

            event.preventDefault();

            $state.go('login');
          });
      }
    });
  }
];
